@if (!actionsTemplate) {
  <ng-template [ngTemplateOutlet]="actionButton"></ng-template>
  <ng-template [ngTemplateOutlet]="cancelButton"></ng-template>
}
@if (actionsTemplate) {
  <ng-template
    [ngTemplateOutlet]="actionsTemplate"
    [ngTemplateOutletContext]="{
      action: actionButton,
      cancel: cancelButton,
    }"></ng-template>
}

<ng-template #actionButton>
  @if (actionVisible) {
    <button
      [disabled]="saving || actionDisabled"
      [attr.form]="id"
      type="submit"
      pplButton
      pplButtonFocusable
      pplButtonDialog
      [pplButtonType]="actionButtonType"
      pplPopover
      [pplPopoverTooltip]="actionTooltip"
      [attr.data-test]="'FormActions_Action'"
      (click)="onSave(); save.emit(null)">
      @switch (actionLabel) {
        @case ('save') {
          <ng-container i18n="@@Save">Save</ng-container>
        }
        @case ('saveAs') {
          <ng-container i18n="@@Save_As">Save As</ng-container>
        }
        @case ('create') {
          <ng-container i18n="@@Create">Create</ng-container>
        }
        @case ('add') {
          <ng-container i18n="@@Add">Add</ng-container>
        }
        @case ('remove') {
          <ng-container i18n="@@Remove">Remove</ng-container>
        }
        @default {
          {{ actionLabel }}
        }
      }
    </button>
  }
</ng-template>

<ng-template #cancelButton>
  @if (cancelVisible) {
    <button
      [disabled]="(cancelDisabledOnSave && saving) || cancelDisabled"
      class="cancel"
      type="button"
      pplButton
      pplButtonFocusable
      pplButtonDialog
      pplButton3
      [attr.data-test]="'FormActions_Cancel'"
      (click)="onCancel(); cancel.emit(null)">
      @switch (cancelLabel) {
        @case ('close') {
          <ng-container i18n="@@Close">Close</ng-container>
        }
        @case ('cancel') {
          <ng-container i18n="@@Cancel">Cancel</ng-container>
        }
        @case ('undoChanges') {
          <ng-container i18n="@@UndoChanges">Undo Changes</ng-container>
        }
        @default {
          {{ cancelLabel }}
        }
      }
    </button>
  }
</ng-template>
